<template>
    <div>
        <p-form @submit="onSubmit">
            <div class="container-fluid content-wrapper" v-if="featureFlag">
                <b-row class="content-heading">
                    <b-col>
                        <div>Edit Feature Flag</div>
                    </b-col>
                    <b-col cols="auto" class="ms-auto">
                        <b-button 
                            type="submit" 
                            variant="primary"
                            :isBusy='isBusy'
                            >Save</b-button
                        >
                    </b-col>
                </b-row>
                <p-card>
                    <b-row>
                        <b-col>
                            <p-input
                                label="Name"
                                v-model="featureFlag.name"
                                :disabled="!isNew"
                            />
                        </b-col>
                        <b-col>
                            <p-input
                                label="Client"
                                v-model="featureFlag.client"
                                disabled
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p-input
                                label="Description"
                                v-model="featureFlag.description"
                                :disabled="!isNew"
                            />
                        </b-col>
                    </b-row>
                    <b-row cols=1 cols-xl="4" cols-lg="2">
                        <b-col>
                            <p-datepicker
                                label="Start Date (UTC)"
                                v-model="featureFlag.startDate"                                                                
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p-checkbox 
                                label="Is Active" 
                                v-model="featureFlag.isActive">
                            </p-checkbox>
                        </b-col>
                    </b-row>
                </p-card>
                <p-card title="Assignments" class="mt-3">
                    <b-row class="mb-3">
                        <b-col cols="2">
                            <p-button
                                variant="outline-primary"
                                v-b-modal.AddDepartmentModel
                                @click="addAssignment">
                                <b-icon-plus></b-icon-plus> Add Assignment
                            </p-button>
                        </b-col>
                        <b-col class="ms-auto">
                            <span class="text-bold">Note: Please use Tenant Abbreviation and UserName to allow feature flag access to a specific user or '*' for all users within a tenant. Asterisk in both fields is effectively turning the feature flag on for all.</span>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p-table
                                :items="featureFlag.featureFlagAssignments"
                                :fields="fields"
                                :enable-row-selection="false">
                                <template v-slot:cell(tenant)="{ value, item }">
                                    <p-input
                                        v-model="item.tenant"
                                    ></p-input>
                                </template>
                                <template v-slot:cell(user)="{ value, item }">
                                        <p-input
                                            v-model="item.user"
                                        ></p-input>
                                </template>
                                <template v-slot:cell(delete)="{ value, item }">
                                    <b-button class="p-1 ms-1 short-button" @click="deleteAssignment(item)">
                                        <BIconTrash icon="trash"></BIconTrash>
                                    </b-button>
                                </template>
                            </p-table>
                        </b-col>
                    </b-row>
                </p-card>
                <b-row>
                    <b-col class='mt-3 text-center'>
                        <p-button variant='primary' type='submit' :isBusy='isBusy'>Save</p-button>
                    </b-col>
                </b-row>
            </div>
        </p-form>
    </div>
</template>

<script>
import pForm from '@/components/p-form.vue';
import axios from 'axios';
import NavigationGuard from '@/components/mixins/NavigationGuard.js';
import PCard from '@/components/p-card.vue';
import editPage from '@/components/mixins/EditPage';

export default {
    mixins: [NavigationGuard, editPage],
    components: { pForm, PCard },
    data() {
        return{
            featureFlag: null,
            isBusy: false,
            tenants: [],
            fields:[
                {
                    key: 'tenant',
                    label: 'Tenant Abbreviation'
                },
                {
                    key: 'user',
                    label: 'User Name'
                },
                {
                    key: 'delete'
                }
            ]
        }
    },
    methods: {
        onSubmit() {
            this.isBusy = true;
            axios
                .post('featureFlags', this.featureFlag)
                .then(response => {
                    this.dataSaved();
                    if (this.isNew) {

                        //figure out ID
                        this.$router.push('/featureFlags/' + response.data.id);
                    }

                    this.$appSuccess(`Feature Flag successfully.`)
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        async loadData(){
            let promise = this.isNew
                ? axios.get('featureFlags/new')
                : axios.get(`featureFlags/${this.id}`);
            promise.then(resp => {
                this.featureFlag = resp.data;
                 if (!this.isNew) {
                    this.dataLoaded();
                }               
            });

            //get tenant list
            axios.get('tenants/search')
                .then(resp => {
                    this.tenants = resp.data.data;   
                });

            this.dataLoaded();
        },
        addAssignment()
        {
            this.featureFlag.featureFlagAssignments.push({ tenant: '', user: ''});
        },
        deleteAssignment(assignment)
        {
            let index = this.featureFlag.featureFlagAssignments.indexOf(assignment);
            if (index !== -1) {
                this.featureFlag.featureFlagAssignments.splice(index, 1);
            }
        }
    },
    mounted: function() {
        this.loadData();
    }
};
</script>

<style></style>
